<template>
  <section>
    <div class="page-header">
      <h3 class="page-title">Einstellungen</h3>
    </div>
    <b-tabs content-class="mt-3">
      <b-tab title="Creditor" active>
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">SEPA Gläubiger (Creditor)</h4>
                <p class="card-description">
                  Wird für die SEPA-XML-Erzeugung in der Rechnungstabelle verwendet.
                </p>
                <b-form-group label="Gläubiger-Name">
                  <b-form-input v-model="form.creditor_name" placeholder="Firmenname" />
                </b-form-group>
                <b-form-group label="Gläubiger-ID (Creditor Scheme ID)">
                  <b-form-input v-model="form.creditor_id" placeholder="DE98ZZZ09999999999" />
                </b-form-group>
                <b-form-group label="IBAN (Empfängerkonto)">
                  <b-form-input v-model="form.creditor_iban" placeholder="DE..." />
                </b-form-group>
                <b-form-group label="BIC">
                  <b-form-input v-model="form.creditor_bic" placeholder="ABCDDEFFXXX" />
                </b-form-group>
                <b-button variant="success" :disabled="saving" @click="save">
                  {{ saving ? 'Speichert…' : 'Speichern' }}
                </b-button>
                <span v-if="saved" class="ml-2 text-success">Gespeichert.</span>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="SEPA Sammler">
        <sepa-merger />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import { getSettings, updateSettings } from '@/services/settings.service';
import SepaMerger from './sepa-merger.vue';

export default {
  name: 'settings',
  components: { SepaMerger },
  data() {
    return {
      form: {
        creditor_name: '',
        creditor_id: '',
        creditor_iban: '',
        creditor_bic: '',
      },
      saving: false,
      saved: false,
    };
  },
  mounted() {
    getSettings().then((resp) => {
      if (resp.data) {
        this.form.creditor_name = resp.data.creditor_name || '';
        this.form.creditor_id = resp.data.creditor_id || '';
        this.form.creditor_iban = resp.data.creditor_iban || '';
        this.form.creditor_bic = resp.data.creditor_bic || '';
      }
    });
  },
  methods: {
    save() {
      this.saving = true;
      this.saved = false;
      updateSettings(this.form)
        .then(() => {
          this.saved = true;
        })
        .finally(() => {
          this.saving = false;
          setTimeout(() => (this.saved = false), 3000);
        });
    },
  },
};
</script>
